import { useConstants } from "../../../redux/hooks";
import { ActivityConfigApplicationConstants } from "./APConfigModel";

export const useActivityConfigConstants = () => {
  const constants = useConstants<ActivityConfigApplicationConstants>();
  return constants;
};
